<template>
  <v-tooltip color="appMain" top :disabled="!showNameTooltip">
    <template v-slot:activator="{ on }">
      <div
        ref="participantName"
        class="content-line__text--selected"
        v-on="on"
        v-resize="isNameOverflow"
      >
        {{ participantName }}
      </div>
    </template>
    <div>
      {{ participantName }}
    </div>
  </v-tooltip>
</template>

<script>
import { isTextOverflow } from '@/filters/helpers';

export default {
  name: 'ParticipantName',
  props: {
    participantName: String,
    isVisible: Boolean,
  },
  data() {
    return {
      showNameTooltip: false,
    };
  },
  methods: {
    async isNameOverflow() {
      await this.$nextTick();

      const el = this.$refs.participantName;
      if (!el || !this.isVisible) return;
      this.showNameTooltip = isTextOverflow(el);
    },
  },
  mounted() {
    this.isNameOverflow();
  },
};
</script>
